import { memo, useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import HookInput from "@/components/Elements/HookInput";
import {
  catchErrors,
  getObjKeysLength,
  putFormValidationFocus,
} from "../../util/functions";
import { REGISTER } from "../../constants/routs.constants";
import { toast } from "react-toastify";
import { authApi } from "@/api";
import { authError, login } from "@/store/authSlice";

const Login = () => {
  const dispatch = useDispatch();

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const isErrorsLength = !!getObjKeysLength(errors);

  useEffect(() => {
    if (isErrorsLength) {
      putFormValidationFocus();
    }
  }, [isErrorsLength]);

  const [submitStatus, setSubmitStatus] = useState(false);

  const onSubmit = async (data) => {
    try {
      setSubmitStatus(true);
      const { access, refresh } = await authApi.login(data);
      localStorage.setItem("access", access);
      localStorage.setItem("refresh", refresh);

      const user = await authApi.getUser();

      dispatch(login(user));
    } catch (e) {
      if (e?.response?.data?.detail) toast.info(e?.response?.data?.detail);
      else toast.info("Unauthorized user.");
    } finally {
      setSubmitStatus(false);
    }
  };

  return (
    <div className="login form__wrapper">
      <Form className="form" onSubmit={handleSubmit(onSubmit)}>
        <h1 className="form__title">Login to account</h1>
        <Row className="mb-2">
          <Col md="6">
            <HookInput
              label="Username"
              inputType="text"
              rules={{
                required: "Required field",
                maxLength: {
                  value: 150,
                  message: "Maximum menu length - 150 characters",
                },
                pattern: {
                  value: /^[\w.@+-]+$/,
                  message: "Only letters, numbers and symbols are allowed",
                },
              }}
              name="username"
              control={control}
              errors={errors}
            />
          </Col>
          <Col md="6">
            <HookInput
              label="Password"
              inputType="password"
              rules={{
                required: "Required field",
                maxLength: {
                  value: 128,
                  message: "Maximum menu length - 128 characters",
                },
              }}
              name="password"
              control={control}
              errors={errors}
            />
          </Col>
        </Row>

        <Button
          className="form__submit"
          type="submit"
          variant="danger"
          disabled={submitStatus}
        >
          {submitStatus ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{" "}
              Signing in
            </>
          ) : (
            "Sign in"
          )}
        </Button>

        {authError &&
          authError.status === 400 &&
          authError.url === "accounts/authenticate/" && (
            <span className="form__validation-message">
              {authError.data.__all__[0]}
            </span>
          )}

        <div className="form__bottom">
          <Link to={REGISTER}>
            <span className="form__link">Create a new account</span>
          </Link>
        </div>
      </Form>
    </div>
  );
};

export default memo(Login);
